//Search
export const CLIENT_DOCUMENT_REQUEST_SEARCH_START_LOADING = "CLIENT_DOCUMENT_REQUEST_SEARCH_START_LOADING";
export const CLIENT_DOCUMENT_REQUEST_SEARCH_END_LOADING = "CLIENT_DOCUMENT_REQUEST_SEARCH_END_LOADING";
export const CLIENT_DOCUMENT_REQUEST_SEARCH_LOADED = "CLIENT_DOCUMENT_REQUEST_SEARCH_LOADED";
export const SET_CLIENT_DOCUMENT_REQUEST_FILTER = "SET_CLIENT_DOCUMENT_REQUEST_FILTER";

//Edit
export const CLIENT_DOCUMENT_REQUEST_START_LOADING = "CLIENT_DOCUMENT_REQUEST_START_LOADING";
export const CLIENT_DOCUMENT_REQUEST_END_LOADING = "CLIENT_DOCUMENT_REQUEST_END_LOADING";
export const CLIENT_DOCUMENT_REQUEST_LOADED = "CLIENT_DOCUMENT_REQUEST_LOADED";
